export default {
  app: {
    tradeOffers: {
      country: 'Kraj',
      loginPrompt: 'Aby zobaczyć oferty handlowe, należy {0}.',
      logIn: 'zalogować się',
    },
  },
};
